import DashboardIcon from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import PeopleAltRoundedIcon from "@material-ui/icons/PeopleAltRounded";
import AccountBalanceRoundedIcon from "@material-ui/icons/AccountBalanceRounded";
import Product from "./components/Product/Product";
import Dashboard from "./components/Dashboard/Dashboard";
import Warehouses from "./components/Warehouses/warehouses";
import Manufacturing from "./components/Manufacturing/ManufacturingPlant";
import Order from "./components/order/order";
import AppOrder from "./components/appOrders/appOrders";
import Partner from "./components/Partner/Partner";
import AppUsers from "./components/AppUsers/AppUsers";
import PartnerRequests from "./components/PartnerRequests/PartnerRequests";
import UserProfile from "./components/UserProfile/UserProfile";
import Users from "./components/Users/Users";
import Category from "./components/Category/Category";
import Series from "./components/Series/Series";
import Parts from "./components/Parts/Parts";
import SalesOrder from "./components/Sales/salesorder";
import PurchaseOrder from "./components/Purchase/purchaseorder";
import Tax from "./components/Tax/Tax";
import Coupons from "./components/Coupons/Coupons";
import Report from "./components/Report/Report";
import GoDown from "./components/goDown/GoDown";
import Location from "./components/location/Location";
import CategoryRoundedIcon from "@material-ui/icons/CategoryRounded";
import ClearAllRoundedIcon from "@material-ui/icons/ClearAllRounded";
import EjectRoundedIcon from "@material-ui/icons/EjectRounded";
import Banner from "./components/Banner/Banner";
import AssignmentIcon from "@material-ui/icons/Assignment";
const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/product",
    name: "Products",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Product,
    layout: "/admin",
    subMenu: [
      {
        name: "Category",
        icon: CategoryRoundedIcon,
        layout: "/admin",
        path: "/categories",
      },
      {
        name: "Parts",
        path: "/parts",
        layout: "/admin",
        icon: EjectRoundedIcon,
      },
      {
        name: "Series",
        path: "/series",
        layout: "/admin",
        icon: ClearAllRoundedIcon,
      },
    ],
  },
  {
    path: "/warehouses",
    name: "Warehouses",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Warehouses,
    layout: "/admin",
    subMenu: [
      {
        name: "Reports",
        icon: AssignmentIcon,
        layout: "/admin",
        path: "/report",
      },
    ]
  },
  {
    path: "/manufacturing",
    name: "Manufacturing",
    rtlName: "طباعة",
    icon: LibraryBooks,
    component: Manufacturing,
    layout: "/admin",
  },
  {
    path: "/banner",
    name: "Banner",
    rtlName: "الرموز",
    icon: Person,
    component: Banner,
    layout: "/admin",
    dontShow: false,
  },
  {
    path: "/apporder",
    name: "App Orders",
    rtlName: "الرموز",
    icon: BubbleChart,
    component: AppOrder,
    layout: "/admin",
  },
  {
    path: "/order",
    name: "Orders",
    rtlName: "الرموز",
    icon: BubbleChart,
    component: Order,
    layout: "/admin",
    subMenu: [
      {
        name: "Sales",
        icon: EjectRoundedIcon,
        layout: "/admin",
        path: "/sales",
      },
      {
        name: "Purchase",
        path: "/purchase",
        layout: "/admin",
        icon: EjectRoundedIcon,
      },
    ],
  },
  {
    path: "/partners",
    name: "Partners",
    rtlName: "الرموز",
    icon: PeopleAltRoundedIcon,
    component: Partner,
    layout: "/admin",
    subMenu: [
      {
        name: "Requests",
        icon: PeopleAltRoundedIcon,
        layout: "/admin",
        path: "/requests",
      },
    ],
  },
  {
    path: "/appusers",
    name: "Customers",
    rtlName: "الرموز",
    icon: PeopleAltRoundedIcon,
    component: AppUsers,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "Users",
    rtlName: "الرموز",
    icon: PeopleAltRoundedIcon,
    component: Users,
    layout: "/admin",
  },
  {
    path: "/tax",
    name: "Tax",
    rtlName: "الرموز",
    icon: AccountBalanceRoundedIcon,
    component: Tax,
    layout: "/admin",
  },
  {
    path: "/coupon",
    name: "Coupons",
    rtlName: "الرموز",
    icon: AccountBalanceRoundedIcon,
    component: Coupons,
    layout: "/admin",
  },
  {

    path: "/report",
    name: "Report",
    rtlName: "الرموز",
    icon: AssignmentIcon,
    component: Report,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/profile",
    name: "User Profile",
    rtlName: "الرموز",
    icon: Person,
    component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/categories",
    name: "Catgories",
    rtlName: "الرموز",
    icon: Person,
    component: Category,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/requests",
    name: "Requests",
    rtlName: "الرموز",
    icon: PeopleAltRoundedIcon,
    component: PartnerRequests,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/series",
    name: "Series",
    rtlName: "الرموز",
    icon: Person,
    component: Series,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/parts",
    name: "Parts",
    rtlName: "الرموز",
    icon: Person,
    component: Parts,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/purchase",
    name: "Purchase",
    rtlName: "الرموز",
    icon: Person,
    component: PurchaseOrder,
    layout: "/admin",
    dontShow: true,
  },
  {
    path: "/sales",
    name: "Sales",
    rtlName: "الرموز",
    icon: Person,
    component: SalesOrder,
    layout: "/admin",
    dontShow: true,
  },
  //  {
  //   path: "/godown",
  //   name: "GoDown",
  //   rtlName: "الرموز",
  //   icon: Person,
  //   component: GoDown,
  //   layout: "/admin",
  //   dontShow: true
  // }, {
  //   path: "/location",
  //   name: "Location",
  //   rtlName: "الرموز",
  //   icon: Person,
  //   component: Location,
  //   layout: "/admin",
  //   dontShow: true
  // },
];

export default dashboardRoutes;
